import React from 'react';
import styles from './Dashboard.module.css';

const ConfirmModal = ({ modal, onClose }) => {
    if (!modal.show) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <h3>{modal.title}</h3>
                <p>{modal.message}</p>
                <button onClick={onClose}>OK</button>
            </div>
        </div>
    );
};

export default ConfirmModal;